import { request } from "./http";

export interface Position {
  id: string;
  instrument_id: string;
  symbol: string;
  asset_class: string;
  side: string;
  quantity: number;
  avg_entry_price: number;
  unrealized_pnl: number;
  realized_pnl: number;
}

export interface PortfolioSummary {
  total_positions: number;
  total_market_value: number;
  total_unrealized_pnl: number;
  total_realized_pnl: number;
  equity: number;
  cash: number;
  buying_power: number;
}

export interface PortfolioResponse {
  positions: Position[];
  summary: PortfolioSummary;
}

export interface EquityPoint {
  timestamp: number;
  equity: number;
}

export const portfolio = {
  get: () => request<PortfolioResponse>("/piggy/api/portfolio"),
  equityCurve: () => request<{ data: EquityPoint[] }>("/piggy/api/equity-curve"),
};
